import { Injectable, signal, Inject } from '@angular/core';
import { APP_CONFIG } from './config.token';

export interface AppConfig {
    production: boolean;
    useMockServices: boolean;
    enableAuth: boolean;
    apiUrl: string;
    cognito: {
        userPoolId: string;
        clientId: string;
        region: string;
    };
    features?: {
        travelerException?: boolean;
        autoApproveThreshold?: boolean;
    };
    monitoring?: {
        slaThresholdMs?: number;
    };
    encryptionKey?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private config: AppConfig;
    
    private _isLoading = signal<boolean>(false);
    public isLoading = this._isLoading.asReadonly();

    constructor(@Inject(APP_CONFIG) config: AppConfig) {
        this.config = config;
    }

    get(key: keyof AppConfig): any {
        return this.config[key];
    }

    get apiUrl(): string {
        return this.config.apiUrl;
    }

    get useMockServices(): boolean {
        return this.config.useMockServices;
    }

    get enableAuth(): boolean {
        return this.config.enableAuth;
    }

    get isProduction(): boolean {
        return this.config.production;
    }

    get cognitoConfig() {
        return this.config.cognito;
    }

    get features() {
        return this.config.features || {};
    }

    get monitoring() {
        return this.config.monitoring || {};
    }

    setLoading(loading: boolean): void {
        this._isLoading.set(loading);
    }

    // Get feature flag
    isFeatureEnabled(feature: string): boolean {
        return this.config.features?.[feature as keyof typeof this.config.features] ?? false;
    }
}
